// App.js
import React, { useState, useEffect } from 'react';
import { useTransition, animated } from 'react-spring';
import './HomeSlider.css';

const Card = ({ icon, title, description, position }) => (
  <div className={`card position-${position}`}>
    <div className="icon">{icon}</div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const Carousel = ({ cards }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % cards.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [cards.length]);

  const transitions = useTransition(index, {
    from: { transform: 'translateX(100%)' },
    enter: { transform: 'translateX(0%)' },
    leave: { transform: 'translateX(-100%)' },
    config: { tension: 120, friction: 14 },
  });

  const getPosition = (i) => {
    const diff = (i - index + cards.length) % cards.length;
    if (diff === 0) return 'center';
    if (diff === 1 || diff === cards.length - 1) return 'adjacent';
    return 'outer';
  };

  return (
    <div className="carousel-container">
      {transitions((style, i) => (
        <animated.div className="carousel" style={style}>
          {cards.map((card, cardIndex) => (
            <Card
              key={cardIndex}
              icon={card.icon}
              title={card.title}
              description={card.description}
              position={getPosition(cardIndex)}
            />
          ))}
        </animated.div>
      ))}
    </div>
  );
};

const App = () => {
  const cardContents = [
    { icon: '⚙️', title: 'Easy to configure', description: 'The carousel comes with lots of options, and configuring the carousel is like a piece of cake!' },
    { icon: '⏱️', title: 'Extremely performant', description: 'react-spring offers very performant results with smooth and natural animations!' },
    { icon: '📱', title: 'Mobile first', description: 'We use @use-gesture to offer the best mobile experience with zero config!' },
    { icon: '🔗', title: 'Custom events', description: 'Thanks to RxJS you\'ll be able to respond to every carousel action in a very simple and elegant way!' },
    { icon: '✒️', title: 'Headless UI', description: 'No more headaches trying to style the elements of the carousel. You control every aspect of the elements of the carousel.' },
  ];

  return (
    <div className="app">
      <h1>A new &lt;Carousel /&gt; experience</h1>
      <div className="buttons">
        <button className="github-button">GitHub</button>
        <button className="npm-button">npm</button>
      </div>
      <Carousel cards={cardContents} />
    </div>
  );
};

export default App;